import React, { useState } from 'react';
import { connect } from 'react-redux';
import { string, bool, func, number } from 'prop-types';

import Field from '~components/Field';
import InputLabel from '~components/InputLabel';
import { actionCreators as homeActions } from '~screens/Dashboard/screens/Home/redux/actions';
import { formatPrice } from '~utils/number';
import { CURRENCY_SYMBOL } from '~constants/environment';

import { TIP_LENGTH_LIMIT, ENTER_KEY } from './constants';
import styles from './styles.module.scss';

function TipCustomAmountButton({
  customText,
  customInput,
  setTip,
  containerClassName,
  handleSelect,
  handleClearSelect,
  index
}) {
  const [showInput, setShowInput] = useState(false);
  const [customTip, setCustomTip] = useState(null);
  const [showCustomTip, setShowCustomTip] = useState(false);

  const handleClick = () => {
    if (customInput) {
      setShowInput(!showInput);
    }

    setCustomTip(null);
    setTip(0);

    if (!customInput || (customInput && customTip)) {
      handleSelect(index);
    }
  };

  const validateCustomTip = candidateTip => {
    if (candidateTip.length <= TIP_LENGTH_LIMIT) {
      setCustomTip(Number(candidateTip));
    }
  };

  const handleSetCustomTip = () => {
    if (customTip > 0) {
      setCustomTip(customTip);
      setTip(customTip);
      handleSelect(index);
      setShowInput(!showInput);
      setShowCustomTip(true);
    }
  };

  const handleEnterKey = event => {
    if (event.key === ENTER_KEY) {
      handleSetCustomTip();
    }
  };

  const handleCloseTipInput = () => {
    handleClearSelect();
    setTip(0);
    setShowCustomTip(false);
    setShowInput(false);
    setCustomTip(null);
  };

  return (
    <>
      {!showInput && (
        <button
          type="button"
          onClick={handleClick}
          className={`${containerClassName} ${styles.customTextButton}`}>
          <div className={`column ${styles.textBox}`}>
            <span className={styles.customTextLabel}>
              {customInput && customTip && showCustomTip ? formatPrice(customTip) : customText}
            </span>
          </div>
        </button>
      )}

      {showInput && (
        <div className={`row ${styles.customTextButton} ${styles.customTipInput}`}>
          <div className="column space-around">
            <span className={styles.tipSign}>{CURRENCY_SYMBOL}</span>
          </div>
          <div className="column space-between">
            <Field
              name="tipField"
              fieldRef={input => input && input.focus()}
              component={InputLabel}
              inputType="text"
              labelContainerClassName={styles.noLabel}
              inputContainerClassName={styles.noBorder}
              inputClassName={styles.tipInput}
              onChange={e => validateCustomTip(e.target.value)}
              onKeyPress={e => handleEnterKey(e)}
              value={customTip}
              noActionsClassName
              actions={
                <div className="column middle">
                  <button type="button" className="m-bottom-1" onClick={e => handleSetCustomTip(e)}>
                    <i className="text-select icon-check-simple" />
                  </button>
                  <button type="button" onClick={handleCloseTipInput}>
                    <i className={`icon-close-thick ${styles.crossIcon}`} />
                  </button>
                </div>
              }
            />
          </div>
        </div>
      )}
    </>
  );
}

TipCustomAmountButton.propTypes = {
  containerClassName: string,
  customInput: bool,
  customText: string,
  handleClearSelect: func,
  handleSelect: func,
  index: number,
  setTip: func
};

const mapDispatchToProps = dispatch => ({
  setTip: tip => dispatch(homeActions.setTip(tip))
});

export default connect(null, mapDispatchToProps)(TipCustomAmountButton);
